export const BOSS_MASTER_DEBUGGER_USERSCRIPT_URL = '/doroparty-boss-debugger.user.js';
export const BOSS_MASTER_DEBUGGER_VERSION = '0.1.0';
const TAMPERMONKEY_INSTALLER_URL = 'https://www.tampermonkey.net/script_installation.php?locale=ko';

export function getBossMasterDebuggerSourceUrl(origin = window.location.origin) {
  return new URL(
    `${BOSS_MASTER_DEBUGGER_USERSCRIPT_URL}?v=${BOSS_MASTER_DEBUGGER_VERSION}`,
    origin,
  ).href;
}

export function getBossMasterDebuggerInstallerUrl(origin = window.location.origin) {
  return `${TAMPERMONKEY_INSTALLER_URL}#url=${getBossMasterDebuggerSourceUrl(origin)}`;
}

export function openBossMasterDebuggerInstaller() {
  window.open(getBossMasterDebuggerInstallerUrl(), '_blank', 'noopener,noreferrer');
}
